import { useNavigate } from "react-router-dom";

import SkillProvidersPage from "../AdminDashboard/SkillProviders/SkillProvidersPage";
import {
  createChannelPartnerSkillProvider,
  deleteChannelPartnerSkillProvider,
  fetchChannelPartnerSkillProvider,
  fetchChannelPartnerSkillProviderStats,
  fetchChannelPartnerSkillProviders,
  updateChannelPartnerSkillProvider,
} from "../../services/channelPartnerPortalApi";
import ChannelPartnerDashboardLayout from "./ChannelPartnerDashboardLayout";

const ChannelPartnerSkillProvidersPage = () => {
  const navigate = useNavigate();

  return (
    <SkillProvidersPage
      fetchStats={fetchChannelPartnerSkillProviderStats}
      fetchItems={fetchChannelPartnerSkillProviders}
      createItem={createChannelPartnerSkillProvider}
      fetchItem={fetchChannelPartnerSkillProvider}
      updateItem={updateChannelPartnerSkillProvider}
      deleteItem={deleteChannelPartnerSkillProvider}
      onViewItem={(provider) => navigate(
        (
          "/channel-partner-portal/skill-providers/work?provider="
          + provider.skill_provider_id
        ),
      )}
      layoutComponent={ChannelPartnerDashboardLayout}
    />
  );
};

export default ChannelPartnerSkillProvidersPage;
